var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tfa-status" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Lock Account",
            visible: _vm.disabling,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.disabling = $event
            },
          },
        },
        [
          _c("div", [
            _c(
              "label",
              {
                staticStyle: { "word-break": "keep-all", "font-size": "18px" },
              },
              [
                _vm._v(
                  "\n        Are you sure you want to disable this account?\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.unlinkDevices,
                  expression: "unlinkDevices",
                },
              ],
              attrs: { id: "unlink_devices", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.unlinkDevices)
                  ? _vm._i(_vm.unlinkDevices, null) > -1
                  : _vm.unlinkDevices,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.unlinkDevices,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.unlinkDevices = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.unlinkDevices = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.unlinkDevices = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticStyle: { "word-break": "keep-all", "font-size": "16px" },
                attrs: { for: "unlink_devices" },
              },
              [
                _vm._v(
                  "\n        All client devices will be unlinked and all users will immediately lose access to the account.\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _c(
                "span",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "el-button el-button--info is-plain",
                      attrs: { size: "small" },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        disabled: !_vm.unlinkDevices,
                      },
                      on: { click: _vm.lock },
                    },
                    [_vm._v("\n          Lock Account\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Unlock Account",
            visible: _vm.enabling,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.enabling = $event
            },
          },
        },
        [
          _c("div", [
            _c(
              "label",
              {
                staticStyle: { "word-break": "keep-all", "font-size": "18px" },
              },
              [
                _vm._v(
                  "\n        Are you sure you want to enable this account?\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.accountVerfied,
                  expression: "accountVerfied",
                },
              ],
              attrs: { id: "verified_identity", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.accountVerfied)
                  ? _vm._i(_vm.accountVerfied, null) > -1
                  : _vm.accountVerfied,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.accountVerfied,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.accountVerfied = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.accountVerfied = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.accountVerfied = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticStyle: { "word-break": "keep-all", "font-size": "16px" },
                attrs: { for: "verified_identity" },
              },
              [
                _vm._v(
                  "\n        I certify that I have gone through the appropriate steps to ensure this account's protection and deem it safe to enabled.\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _c(
                "span",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "el-button el-button--info is-plain",
                      attrs: { size: "small" },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        disabled: !_vm.accountVerfied,
                      },
                      on: { click: _vm.lock },
                    },
                    [_vm._v("\n          Unlock Account\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("el-switch", {
        attrs: {
          size: "small",
          "active-text": "YES",
          "inactive-text": "NO",
          disabled:
            _vm.locking ||
            _vm.disabling ||
            _vm.enabling ||
            !_vm.userHasPermission({ permission: "lock", on: "Customer" }),
        },
        on: { change: _vm.change },
        model: {
          value: _vm.locked,
          callback: function ($$v) {
            _vm.locked = $$v
          },
          expression: "locked",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }